module.exports = __webpack_public_path__ + "img/nature-43.f5f6e762.jpg";